import { getUnusualEvents } from '../../api/unusual';
import { getAnalytics } from '../../api/analytics';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_DUMP_POTATO_VALUE = 'CHANGE_DUMP_POTATO_VALUE';
export const CHANGE_DUMP_POTATO_SEVERAL_VALUES = 'CHANGE_DUMP_POTATO_SEVERAL_VALUES';
export const CHANGE_DUMP_POTATO_CURRENT_IMAGE = 'CHANGE_DUMP_POTATO_CURRENT_IMAGE';
export const SET_DUMP_POTATO_EVENT_IMAGE = 'SET_DUMP_POTATO_EVENT_IMAGE';
export const RESET_DUMP_POTATO_STORE = 'RESET_DUMP_POTATO_STORE';

export const GET_DUMP_POTATO = 'GET_DUMP_POTATO';
export const GET_DUMP_POTATO_SUCCESS = 'GET_DUMP_POTATO_SUCCESS';
export const GET_DUMP_POTATO_ERROR = 'GET_DUMP_POTATO_ERROR';

export const GET_DUMP_POTATO_ANALYTIC = 'GET_DUMP_POTATO_ANALYTIC';
export const GET_DUMP_POTATO_ANALYTIC_SUCCESS = 'GET_DUMP_POTATO_ANALYTIC_SUCCESS';
export const GET_DUMP_POTATO_ANALYTIC_ERROR = 'GET_DUMP_POTATO_ANALYTIC_ERROR';

export const getDumpPotatoAction = (function () {
  let prevController;

  return (params, actions = {}) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_DUMP_POTATO });
      try {
        const response = await getUnusualEvents(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_DUMP_POTATO_SUCCESS, payload: results, params });
          actions.onSuccess && actions.onSuccess(results.content);
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_DUMP_POTATO_ERROR });
          actions.onError && actions.onError(error.message);
        }
      }
    };
  };
})();

export const getDumpPotatoAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_DUMP_POTATO_ANALYTIC });
      try {
        const response = await getAnalytics(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_DUMP_POTATO_ANALYTIC_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_DUMP_POTATO_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const changeValue = (key, value) => ({
  type: CHANGE_DUMP_POTATO_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_DUMP_POTATO_SEVERAL_VALUES,
  payload: value,
});

export const changeCurrentImage = (index, value) => ({
  type: CHANGE_DUMP_POTATO_CURRENT_IMAGE,
  payload: { index, value },
});

export const setEventImage = (eventId, index, image) => ({
  type: SET_DUMP_POTATO_EVENT_IMAGE,
  payload: { eventId, index, image },
});

export const resetStore = () => ({
  type: RESET_DUMP_POTATO_STORE,
});
